"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOTTOM_AXIS_MARGIN = exports.ROTATE_NEGATIVE_60_DEGREES = exports.ROTATE_NEGATIVE_90_DEGREES = exports.ROTATE_60_DEGREES = exports.ROTATE_90_DEGREES = exports.ALIGN_RIGHT = exports.ALIGN_LEFT = void 0;
// (C) 2019 GoodData Corporation
exports.ALIGN_LEFT = "left";
exports.ALIGN_RIGHT = "right";
exports.ROTATE_90_DEGREES = "90";
exports.ROTATE_60_DEGREES = "60";
exports.ROTATE_NEGATIVE_90_DEGREES = "-90";
exports.ROTATE_NEGATIVE_60_DEGREES = "-60";
exports.BOTTOM_AXIS_MARGIN = 8;
//# sourceMappingURL=axisLabel.js.map